<template>
  <div>

    <div class="banner" v-if="showBanner" @click="goAnswer">
      <img v-if="banner" :src="banner" alt="">
      <div class="privacy" @click.stop>
        <div style="display: inline-flex;position: relative; height: 14px;">
          <el-checkbox v-model="privacyConfirm" :border="true"
            style="width:14px !important;height:14px !important;padding: 0 !important;overflow: hidden;"></el-checkbox>
          <div style="margin-left: 5px;">我已阅读并同意<a class="link" @click.stop="showPrivacy()">{{ '隐私政策' }}</a></div>
        </div>

      </div>
    </div>
    <div class="banner" v-if="isOver">
      <img v-if="endBanner" :src="endBanner" alt="">
    </div>
    <div class="surveyBox" v-if="!showBanner">
      <div class="survey" v-if="!isOver">
        <el-progress :text-inside="true" :stroke-width="26" :percentage="percent"></el-progress>
        <div class="questions">
          <div class="question" v-for="(question, index) in questions" v-show="curIndex === index" :key="index">
            <div class="name">
              {{ index + 1 }}. {{ question.name }}
              <span v-if="question.depText">(依赖于 {{ question.depText }})</span>
            </div>
            <div class="description" v-html="question.detail"></div>
            <div class="options" v-if="question.type === 1">
              <div class="option" v-for="(item, i) in question.items" :key="i">
                <el-radio v-model="questions[index].selected" :label="item.id">{{ item.content }}</el-radio>
                <span class="orange" v-if="question.skips && question.skips.length">
                  <template v-if="question.skips[i].type === 4">
                    (跳转至 第{{ question.skips[i].sort }}题 {{ question.skips[i].name }})
                  </template>
                  <template v-if="question.skips[i].type === 3">
                    (视为无效问卷)
                  </template>
                  <template v-if="question.skips[i].type === 2">
                    (跳转至 问卷结尾)
                  </template>
                </span>
                <el-input maxlength="250" style="margin-top: 6px" v-model="questions[index].items[i].context"
                  placeholder="请输入内容" v-if="item.isInput && questions[index].selected == item.id"
                  @input="e => questions[index].items[i].context = e.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')">
                </el-input>
              </div>
            </div>
            <div class="options" v-if="question.type === 2">
              <el-checkbox-group v-model="questions[index].selected">
                <div class="option" v-for="(item, i) in question.items" :key="i">
                  <el-checkbox :label="item.id">{{ item.content }}</el-checkbox>
                  <span class="orange" v-if="question.skips && question.skips.length">
                    <template v-if="question.skips[i].type === 4">
                      (跳转至 第{{ question.skips[i].sort }}题 {{ question.skips[i].name }})
                    </template>
                    <template v-if="question.skips[i].type === 3">
                      (视为无效问卷)
                    </template>
                    <template v-if="question.skips[i].type === 2">
                      (跳转至 问卷结尾)
                    </template>
                  </span>
                  <el-input maxlength="250" style="margin-top: 6px" v-model="questions[index].items[i].context"
                    placeholder="请输入内容" v-if="item.isInput && questions[index].selected.indexOf(item.id) != -1"
                    @input="e => questions[index].items[i].context = e.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')">
                  </el-input>
                </div>
              </el-checkbox-group>
            </div>
            <div class="score" v-if="question.type === 3">
              <el-rate v-model="questions[index].score" :icon-classes="iconClasses" void-icon-class=""
                :max="question.maxScore + 1">
              </el-rate>
              <div class="scoreText">
                <span v-for="count in question.maxScore + 1" :key="count">{{ count - 1 }}</span>
              </div>
              <div class="scoreExp">
                <span v-html="question.leftLabel"></span>
                <span v-html="question.rightLabel"></span>
              </div>
              <!--
              <star-rate v-model="questions[index].score"
                         active-color="#67c23a" inactive-color="#ccc"
                         hover-color="#67c23a" :count="question.maxScore" />-->
              <!--<el-input v-model="questions[index].score" placeholder="请输入分值"></el-input>-->
              <!--<span class="scoreTip">最高 {{ question.maxScore }} 分</span>-->
            </div>
            <div class="description" v-if="question.type === 4">
              <el-input maxlength="250" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入内容"
                v-model="questions[index].description"
                @input="e => questions[index].description = e.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')">
              </el-input>
            </div>
            <div class="description" v-if="question.type === 5">
              <div style="margin-top:20px" v-for="(item, i) in question.items" :key="i"
                v-if="questions[index].items[i].inUse">
                <span :label="item.id">{{ item.content }}
                </span>
                <el-select :no-data-text="doorLoading ? '查询中......' : '暂无数据'" id="remote-filter-door"
                  v-if="questions[index].items[i].tag === 'door'" maxlength="250" style="margin-top: 6px;width:100%"
                  v-model="questions[index].items[i].context"
                  :placeholder="'请输入' + (!tags[questions[index].items[i].tag] ? '内容' : tags[questions[index].items[i].tag])"
                  @input="e => questions[index].items[i].context = e.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')"
                  filterable remote :remote-method="filterDoor" :popper-append-to-body="false">
                  <el-option v-for="item in doors" :key="item.posId" :label="item.doorName" :value="item.posId">
                    <div style="position: relative;width: 100%;">
                      <div style="position:absolute;left:0;color: #666666;width: 60px;">{{ item.posId }}</div>
                      <div
                        style="position:absolute;right:0;width: calc(100% - 60px);text-align:right;font-size: 13px;font-weight: 600;text-overflow: ellipsis;overflow: hidden;">
                        {{ item.doorName
                        }}</div>
                    </div>
                  </el-option>
                </el-select>
                <el-input v-else-if="questions[index].items[i].tag == 'email'" maxlength="250" style="margin-top: 6px"
                  v-model="questions[index].items[i].context"
                  :placeholder="'请输入' + (!tags[questions[index].items[i].tag] ? '内容' : tags[questions[index].items[i].tag])"
                  @input="e => questions[index].items[i].context = e.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')">
                  <!-- <template slot="append">@xiaomitaotao.com</template> -->
                </el-input>
                <el-input v-else maxlength="250" style="margin-top: 6px" v-model="questions[index].items[i].context"
                  :placeholder="'请输入' + (!tags[questions[index].items[i].tag] ? '内容' : tags[questions[index].items[i].tag])"
                  @input="e => questions[index].items[i].context = e.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, '')">
                </el-input>
              </div>
            </div>
            <div style="width:100%;margin-top:20px" v-if="question.needUpload">
              <div style="color:#666666;font-size:16px;font-weight:400">上传图片：</div>
              <input id="upload-btn" type="file" @change="handleFile($event)" style="display:none" capture="camera"
                accept="image/*">
              <input id="upload-btn2" type="file" @change="handleFile($event)" style="display:none" accept="image/*">
              <div style="margin-top:6px;width:100%;display: flex;height:25vw;">
                <div v-loading="loading[i - 1]"
                  v-for="i in question.uploadImages.length <= 2 ? question.uploadImages.length + 1 : 3"
                  style="margin-right: 10px;width:25vw;height:25vw;background-color:#ebeef5;display:flex;align-items: center;justify-content: center;overflow: hidden;"
                  @click="uploadClick(i - 1)">
                  <div style="position: relative;height: 25vw;" v-if="question.uploadImages[i - 1]">
                    <img :src="question.uploadImages[i - 1]" alt="" style="width:25vw;height:25vw;" />
                    <div
                      style="position: absolute; right:0;bottom: 0; width:6vw;height:6vw;line-height: 6vw;color:white;background-color: rgba(0, 0, 0, 0.4);text-align: center;border-radius: 5px 0 0 0;"
                      @click.stop="question.uploadImages.splice(i - 1, 1)">
                      <i class="el-icon-delete"></i>
                    </div>

                  </div>
                  <i v-else class="el-icon-plus" style="color: darkgray;font-size: 10vw;font-weight: 600;"></i>
                </div>
              </div>
              <div style="color:#b6b6b6;font-size:14px;font-weight:400;margin-top: 5px;">注:避免拍摄/上传带有人脸照片</div>
            </div>
          </div>
        </div>

        <div class="buttons" v-if="!isLast">
          <el-button @click="prevQuestion()">返回上一题</el-button>
          <el-button type="primary" @click="nextQuestion()">进入下一题</el-button>
        </div>
        <div style="text-align: center;margin-top:20px" v-if="isLast">
          <el-button type="primary" @click="nextQuestion()">确 定</el-button>
        </div>
      </div>


      <!--    <div class="test" @click="saveSurvey">111111</div>-->
    </div>
    <el-dialog width="90%" :visible.sync="privacyShow" center>
      <template slot="title">
        <div style="font-weight: 600;font-size: 18px;text-decoration: underline;">隐私政策</div>
      </template>
      <div style="font-size: 14px;height: 60vh;overflow-y: auto;">
        <p>更新及生效日期：2024年 5 月</p>
        <p>耐克体育（中国）有限公司（注册地址：中国上海市杨浦区江湾城路99号）负责处理通过Retailink平台获得的您的个人信息。</p>
        <p style="font-weight: 600;">一、我们如何收集、处理您的个人信息</p>
        <p>在您使用Retailink平台时，为了向您提供平台功能，我们会收集并处理您提交的或我们可能要求您提交的个人信息，具体包括：</p>
        <el-table key="privacy-data" :data="privacyData" border style="width: 100%">
          <el-table-column prop="show" label="功能场景" width="80%">
          </el-table-column>
          <el-table-column prop="info" label="您的个人信息" width="110%">
          </el-table-column>
          <el-table-column prop="target" label="手机目的及用途">
          </el-table-column>
        </el-table>
        <p>
          请注意，若您在使用Retailink平台时，向我们提供除您（或您的被监护人）以外其他自然人的个人信息时，请确保您已获取该自然人的合法有效同意或授权。若由于您违法违规提供他人个人信息导致我们承担任何法律后果，我们将保留追责的权利。
        </p>
        <p style="font-weight: 600;">二、我们如何委托处理、提供、转让、公开披露您的个人信息</p>
        <p style="font-weight: 600;">1、委托处理</p>
        <p>
          为了更好地提供Retailink平台的功能和我们的服务，某些功能可能由我们的技术服务合作方提供技术服务，同时我们也可能委托他人处理您的某些个人信息。对我们委托处理您个人信息的公司、组织和个人，我们会与其签署严格的保密协定，约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督，一旦委托关系终止，我们会要求受托人返还个人信息或予以删除，不得保留。
        </p>
        <p style="font-weight: 600;">2、对外提供信息</p>
        <p>除委托处理以外，除非征得您的单独同意，否则我们不会向本隐私政策载明之外的第三方公司、组织或个人提供您的个人信息。</p>
        <p style="font-weight: 600;">3、信息转移</p>
        <p>
          未经您的同意，我们不会将您的个人信息转移至第三方公司、组织或个人。如因合并、分立、解散、被宣告破产等原因确需转移，在转移之前，我们将向您告知接收方的名称或者姓名和联系方式，并要求接收方继续履行个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，我们将要求其依照法律规定重新取得您的同意。
        </p>
        <p style="font-weight: 600;">4、公开披露</p>
        <p>我们不会公开我们所处理的您的个人信息，除非取得您单独同意。 但请注意，若您主动公开、共享您的个人信息到第三方平台（如微信好友/朋友圈/
          QQ等）。在这种情况下，共享信息将被即时并广泛的传播。一旦您进行了此类公开共享，我们将对此不承担任何法律责任。我们也可能依政府的要求、法院命令、在法律规定情况下或为了保护我们或其他人的权利、财产或安全时，以及为防止违法使用网站时，披露或共享您的个人信息。
        </p>
        <p style="font-weight: 600;">三、我们如何保护未成年人的个人信息</p>
        <p>请您知悉，我们根据我国法律法规的要求，保护未成年人的个人信息安全。但由于Retailink平台的服务并不面向未成年人，我们无意收集未成年人（尤其是不满14周岁的未成年人）的个人信息。</p>
        <p style="font-weight: 600;">四、我们如何存储您的个人信息</p>
        <p>
          Retailink平台收集、使用您的个人信息，将进行本地化存储。根据法律法规要求，如果涉及跨境传输您的个人信息的，我们会征求您的单独同意。您的个人信息将在实现本隐私政策所述目的所需的合理时间内保存（除非适用法律要求更长的保存期限）。
        </p>
        <p style="font-weight: 600;">五、您的个人信息权利</p>
        <p>您有权要求：(i) 访问您的个人信息；(ii) 获取您个人信息副本；(iii) 如不完整或有误，更正您的个人信息；(iv) 删除您的个人信息；或 (v)
          在适用法律规定的某些情况下，关闭您的账户。这些权利不是绝对的。如果我们已获得了您对处理您个人信息的同意，您有权随时撤销该同意。</p>
        <p>如果您想要行使您的任何权利，请向 privacy@nike.com 发送电子邮件。</p>
        <p style="font-weight: 600;">六、保密和保护</p>
        <P>Retailink平台使用一系列安全技术和程序来保护您的个人信息免遭未授权访问、使用和披露。平台收集的个人信息存储在普通公众无法访问的安全环境中。</P>
        <p style="font-weight: 600;">七、到其他网站或平台的链接</p>
        <p>
          Retailink平台可能会提供到其他网站、平台的链接，向您提供便利和信息。这些网站、平台可能独立运行，并且可能有自己的隐私声明或政策，我们强烈建议您查看。在任何链接到的网站、平台不归我们拥有或控制的情况下，我们对其内容、使用行为或该网站、平台的隐私做法概不负责。
        </p>
        <p style="font-weight: 600;">八、我们隐私政策的修改</p>
        <p>
          如果我们决定修改我们的隐私政策，我们将在Retailink平台上发布修改后的政策。建议您定期查看我们的隐私政策是否有修改。如果我们对我们处理您个人信息的方式做出了重大修改，我们将提前通知您；如法律规定，我们还会在实施此等修改前征求您的同意或确保存在此等处理的其他法律依据。本政策最后修改日期为2024年5月。
        </p>
        <p style="font-weight: 600;">九、疑问和反馈</p>
        <p>如果您希望提供反馈或有问题或疑虑，请通过以下方式联系我们：(i) 发送邮件至 privacy@nike.com；或 (ii) 邮寄至中国上海江湾城路 99 号隐私办公室。</p>
      </div>

    </el-dialog>
    <el-drawer :visible.sync="bottomDrawer" :direction="'btt'" :with-header="false" style="padding: 20px;" :size="120">
      <div style="display: block; width: 100%; text-align: center;padding: 20px;overflow: hidden;">
        <div
          style="width: 100%;height: 39px;font-size: 16px;line-height: 39px;font-weight: 600;border-bottom:solid 1px #666666;"
          @click="fileSelect(1)">相机</div>
        <div style="width: 100%;height: 39px;font-size: 16px;line-height: 39px;font-weight: 600;"
          @click="fileSelect(2)">相册
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
/** 需要数据有:
  * 题目序号
  * 题目名称
  * 题目id
  * 题目类型(单选,多选,打分,描述)
  * 题目依赖(数组)
  *   依赖的题目的序号,id,选项序号,选项id,选项内容
  * 题目选项
  *   选项的序号,id,选项内容
  *   选项的跳转,跳转到的题目的id,题目名称,题目序号
  * 题目最大分值
  *
  * */
import _ from 'lodash'
import StarRate from 'vue-cute-rate'
import axios from 'axios'
// import ImageCompressor from 'js-image-compressor'
export default {
  name: 'Survey',
  components: {
    StarRate
  },
  data() {
    return {
      surveyId: this.$route.query.id || null,
      doorNo: this.$route.query.doorNo || 0,
      loading: { 0: false, 1: false, 2: false },
      questions: [],
      curIndex: 0, // 当前所在第几题
      selected: null,
      isOver: false, // 问卷是否结束
      isLast: false,
      isValid: true, // 问卷是否有效
      startTime: '', // 开始时间
      endTime: '', // 结束时间
      extraForm: {
        gender: '', //
        age: ''
      },
      surveys: [],
      doorId: '',
      progress1: '',
      progress2: '',
      progress3: '',
      tags: {
        email: '邮箱',
        door: '门店门店编号或门店名',
        cellphone: '手机号',
        name: '姓名'
      },
      scores: [
        {
          content: '(非常满意,当然会推荐)',
          index: 10

        },
        {
          content: '',
          index: 9
        },
        {
          content: '',
          index: 8
        },
        {
          content: '(不太确定是否会推荐)',
          index: 7
        },
        {
          content: '',
          index: 6
        },
        {
          content: '',
          index: 5
        },
        {
          content: '',
          index: 4
        },
        {
          content: '',
          index: 3
        },
        {
          content: '',
          index: 2
        },
        {
          content: '',
          index: 1
        },
        {
          content: '(不满意,一定不会推荐)',
          index: 0
        }],
      banner: '',
      endBanner: '',
      coverImage: '',
      showBanner: true,
      imageIndex: 0,
      doors: [],
      iconClasses: ['el-icon-rate-on', 'el-icon-rate-on', 'el-icon-rate-on'],
      privacyShow: false,
      privacyConfirm: false,
      privacyData: [{
        show: '问卷填写',
        info: '邮箱、姓名（可选）、手机号（可选）',
        target: '当您在Retailink平台上填写问卷调查时需提供这些个人信息，以便您后续的问卷填写。我们也会将您的问卷填写内容导出，在公司内部进行数据分析。这些信息是完成问卷填写所必需的，若您拒绝提供，将无法填写问卷。'
      }],
      doorLoading: false,
      bottomDrawer: false,
    }
  },
  mounted() {
    this.preventTouch()
    this.getSurveyDetail()
    this.startTime = this.getTime()
    this.initBodyBackground()
    console.log('this.startTime', this.startTime)
  },
  methods: {
    goAnswer() {
      if (!this.privacyConfirm) {
        this.$message.error("请阅读并勾选同意隐私政策！")
        return
      };
      this.showBanner = false
    },
    showPrivacy() {
      this.privacyShow = true
    },
    initBodyBackground() {
      document.getElementsByTagName('body')[0].className = 'white'
    },
    preventTouch() {
      document.documentElement.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      }, false)
      var lastTouchEnd = 0
      document.documentElement.addEventListener('touchend', function (event) {
        var now = Date.now()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      }, false)
    },
    getUuid() {
      var s = []
      var hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'

      var uuid = s.join('')
      return uuid
    },

    async getSurveyDetail() {
      let res = await window.instance.get(openSurveyReqUrl + 'questionnaire/' + this.surveyId)

      res = res.data
      if (res.code === 200) {
        // this.doorId = res.data.id;
        this.banner = res.data.startImage
        this.endBanner = res.data.endImage
        this.coverImage = res.data.coverImage
        let bodyStyle = document.body.style
        bodyStyle.background = 'url(' + this.coverImage + ')'
        if (!this.banner) {
          this.showBanner = false
        }

        let questions = res.data.questions

        if (this.curIndex == questions.length - 1) {
          this.isLast = true;
        }

        this.computeProgressTag(questions.length)

        _.each(questions, (question) => {
          if (question.type === 1) {
            question.selected = null
            question.selectedIndex = null
          } else if (question.type === 2) {
            question.selected = []
            question.selectedIndex = []
          } else if (question.type === 3) {
            question.score = null
          } else if (typeof question.type === 4) {
            question.description = ''
          }

          question.uploadImages = []

          if (question.dependOn && question.dependOn.length) {
            var depText = ''
            _.each(question.dependOn, (dep) => {
              var depIndex = dep.sort
              var depItemText = '第' + depIndex + '题'
              if (dep.type != 3) {
                _.each(dep.itemSort, (item, i) => {

                  console.log('itemIndex', item)
                  var itemIndex = item
                  var itemName = questions[depIndex - 1].items[itemIndex - 1].content
                  depItemText += ' ' + '选项' + itemIndex + ' ' + itemName

                })
              } else {
                console.log('depQuestionType', dep.type)
                _.each(dep.scoreRanges, (score, i) => {
                  var startScore = score.start
                  var endScore = score.end
                  if (score.enable) {
                    depItemText += ' ' + startScore + '-' + endScore + '分'
                  }
                })
              }
              depText += ' ' + depItemText
            })

            question.depText = depText
          }
        })
        this.questions = questions
        console.log('this.questions', this.questions)
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
    },

    computeProgressTag(length) {
      this.progress1 = _.floor(length * 0.25)
      this.progress2 = _.floor(length * 0.5)
      this.progress3 = _.floor(length * 0.75)
    },

    // 进入下一题
    nextQuestion() {
      if (this.loading[0] || this.loading[1] || this.loading[2]) {
        return;
      }
      var curQuestion = this.questions[this.curIndex]
      var curType = curQuestion.type
      if (curQuestion.needUpload && curQuestion.mustUpload && curQuestion.uploadImages.length == 0) {
        this.$message({
          type: 'error',
          message: '请上传至少一张图片！'
        })
        return;
      }

      if (curType === 1) {
        curQuestion.selectedIndex = null;

        var selectedItemId = curQuestion.selected
        var isInputFill = true //'其他'input是否填写内容
        _.each(curQuestion.items, (item, index) => {
          // 1.获取选中的选项索引
          if (item.id == selectedItemId) {
            curQuestion.selectedIndex = index + 1;
            if ((item.isInput && item.necessary) && !item.context) {
              isInputFill = false
            }
          }
        })
        if ((selectedItemId || !curQuestion.necessary) && isInputFill) {

          // 2. 从对应的项获取跳转目标排序
          let skipTo = 0
          if (curQuestion.selectedIndex) {
            skipTo = curQuestion.items[curQuestion.selectedIndex - 1]['skipTo']
          }

          if (skipTo === 0) {
            // 顺序跳转
            this.setNext()
          } else if (skipTo === -1) {
            // 跳转至问卷结束
            this.endSurvey()
          } else {
            // 跳转到指定题目
            var skipIndex = skipTo - 1
            var curIndex = this.curIndex
            this.curIndex = skipIndex
            this.questions[this.curIndex].prev = curIndex
          }
        } else {
          this.$message({
            type: 'error',
            message: '请完成答题'
          })
        }
      } else if (curType === 2) {
        /*
        * 多选题的跳转问题:
        * 多选题可以给各个选项设置不同的跳转,用户在选择的时候,选择了某一项,跳转到哪一项,
        * 但如果用户选择多项设置了不同跳转的项,则以用户选择的第一个选项的跳转为准
        * */
        var selectedItemIds = curQuestion.selected
        // 获取所有选中的项
        var selectedItems = []
        curQuestion.selectedIndex = [];
        _.each(curQuestion.items, (item, index) => {
          if (_.indexOf(selectedItemIds, item.id) != -1) {
            selectedItems.push(item)
          }
        })
        // 判断选中的项是否input且有填写内容
        var isInputFill = true
        _.each(selectedItems, (item, index) => {
          if ((item.isInput && item.necessary) && !item.context) {
            isInputFill = false
          }
        })
        if (!isInputFill) {
          this.$message({
            type: 'error',
            message: '请完成答题'
          });
          return false
        }
        if (selectedItemIds.length || !curQuestion.necessary) {
          /* 判断最多选择几项,最少选择几项,是否符合 */
          const optionMax = curQuestion.optionMax
          const optionMin = curQuestion.optionMin
          if (selectedItemIds.length > optionMax) {
            this.$message({
              type: 'error',
              message: '最多选择' + optionMax + '项'
            });
            return false
          }
          if (selectedItemIds.length < optionMin) {
            this.$message({
              type: 'error',
              message: '至少选择' + optionMin + '项'
            });
            return false
          }

          // 1. 获取每一个选中项的index
          _.each(curQuestion.items, (item, index) => {
            _.each(selectedItemIds, (selectedItemId) => {
              if (item.id == selectedItemId) {
                curQuestion.selectedIndex.push(index + 1)
              }
            })
          })
          // 2. 获取第一个选中项的index
          let selectedItemIndex = curQuestion.selectedIndex[0]

          // 3. 从skips里拿到对应的项
          let skipTo = 0
          if (selectedItemIndex) {
            skipTo = curQuestion.items[selectedItemIndex - 1]['skipTo']
          }


          if (skipTo === 0) {
            // 顺序跳转
            this.setNext()
          } else if (skipTo === -1) {
            // 跳转至问卷结束
            this.endSurvey()
          } else {
            // 跳转到指定题目
            var skipIndex = skipTo - 1
            var curIndex = this.curIndex
            this.curIndex = skipIndex
            this.questions[this.curIndex].prev = curIndex
          }
        } else {
          this.$message({
            type: 'error',
            message: '请完成答题'
          })
        }
      } else if (curType === 3) {
        if (_.isNil(curQuestion.score) && curQuestion.necessary) {
          this.$message({
            type: 'error',
            message: '请完成答题'
          })
          return false
        }
        var selectedScore = _.toNumber(curQuestion.score) - 1
        var maxScore = curQuestion.maxScore
        if (!curQuestion.necessary || (selectedScore !== -1 && selectedScore <= maxScore)) {
          // if (curQuestion.scoreSkip && curQuestion.scoreSkip.length) {
          var isInScoreArea = false // 分数是否在所有的区间里,如果是false,表示分数不在任何区间
          _.each(curQuestion.scoreSkip, (skip) => {
            var startScore = skip.start
            var endScore = skip.end
            if (startScore < selectedScore && selectedScore <= endScore) {
              isInScoreArea = true
              var skipTo = skip['skipTo']
              if (skipTo === 0) {
                // 顺序跳转
                this.setNext()
              } else if (skipTo === -1) {
                // 跳转至问卷结束
                this.endSurvey()
              } else {
                // 跳转到指定题目
                this.skipToQuestion(skip.skipTo - 1)
              }
            }
          })
          if (!isInScoreArea) {
            this.setNext()
          }
          // } else {
          //   this.setNext()
          // }
        } else if (selectedScore === -1 && curQuestion.necessary) {
          this.$message({
            type: 'error',
            message: '请选择分值'
          })
        } else if (selectedScore > maxScore) {
          this.$message({
            type: 'error',
            message: '打分不得大于最大分值'
          })
        }
      } else if (curType === 4) {
        var enteredDesc = curQuestion.description
        if (!enteredDesc && curQuestion.necessary) {
          this.$message({
            type: 'error',
            message: '请完成答题'
          })
        } else {
          this.setNext()
        }
      } else if (curType === 5) {
        var isInputFill = true
        _.each(curQuestion.items.filter(i => i.inUse), (item, index) => {
          if ((item.isInput && item.necessary) && !item.context) {
            isInputFill = false
          }
        })
        if (!isInputFill) {
          this.$message({
            type: 'error',
            message: '请完成答题'
          });
          return false
        } else {
          this.setNext()
        }
      } else {
        this.setNext()
      }
    },
    // 返回上一题
    prevQuestion() {
      if (this.loading[0] || this.loading[1] || this.loading[2]) {
        return;
      }
      var curQuestion = this.questions[this.curIndex]
      var prevIndex = curQuestion.prev
      if (!_.isNil(prevIndex)) {
        this.curIndex = prevIndex
      } else {
        this.curIndex = this.curIndex - 1
        if (this.curIndex < 0) {
          this.curIndex = 0
        }
      }
    },

    // 获取题目的依赖
    // 返回true表示这题可以显示,返回false表示没有满足依赖条件,这题不能显示
    getQuestionDep(index) {
      var result = true
      var questionDetail = this.questions[index]
      if (questionDetail.dependOn && questionDetail.dependOn.length) {
        // denendType == 1   '或' 逻辑,表示只要任何一条depend满足,就可以满足
        // denendType == 0   '且' 逻辑,则必须每条depend都要满足
        var dependType = questionDetail.dependType
        console.log('dependType', dependType)
        for (var i = 0; i < questionDetail.dependOn.length; i++) {
          var dep = questionDetail.dependOn[i]
          var depQuesionSequence = dep.sort
          var depQuestion = this.questions[depQuesionSequence - 1]
          var depQuestionType = depQuestion.type
          // 依赖于单选题
          if (depQuestionType === 1) {
            var depItems = dep.itemSort;

            var depQustionSelected = depQuestion.selectedIndex
            console.log('depItems', depItems)
            console.log('depQustionSelected', depQustionSelected)
            if (_.indexOf(depItems, depQustionSelected) !== -1) {
              // 满足当前depend条件,如果是 ‘’或’’ 逻辑,直接满足返回true
              if (dependType == 1) {
                return true
              }
            } else {
              // 不满足当前depend条件,如果是 ‘’且’’ 逻辑
              result = false
            }
          }
          // 依赖于多选题
          if (depQuestionType === 2) {
            var depItems = dep.itemSort;
            var depQustionSelected = depQuestion.selectedIndex
            console.log('depItems 依赖项', depItems)
            console.log('depQustionSelected 选择项', depQustionSelected)
            var allItems = _.union(depItems, depQustionSelected)
            if (allItems.length === depItems.length + depQustionSelected.length) {
              // 表示没有重复的数,表示依赖项没有被选中的
              result = false
            } else {
              // 表示有重复的数,依赖项被选中,满足条件
              // 如果是 ‘’或’’ 逻辑,直接满足返回true
              if (dependType == 1) {
                return true
              }
            }
          }
          // 依赖于打分题
          else if (depQuestionType === 3) {
            var depQuestionScore = depQuestion.score
            console.log('depQuestionScore', depQuestionScore)
            var isScoreInArea = false
            _.each(dep.scoreRanges, (score) => {
              if (score.enable) {
                if (score.start < depQuestionScore && depQuestionScore <= score.end) {
                  isScoreInArea = true
                }
              }
            })
            if (isScoreInArea) {
              // 满足依赖条件, 如果是 ‘’或’’ 逻辑,直接满足返回true
              if (dependType == 1) {
                return true
              }
            } else {
              result = false
            }
          }
        }
        _.each(questionDetail.dependOn, (dep) => {

        })
        return result
        /*
        * 1. 获取依赖题目的编号
        * 如果是选择题:
        *   1) 找到依赖的题目
        *   2) 获取依赖的题目的选中项
        *   3) 获取依赖的选项
        *   4) 对比依赖的题目的选中项,是否包含了依赖的选项
        *     4.1) 包含:返回pass,判断下一个依赖
        *     4.2) 不包含,结束函数,返回false
        * 如果是打分题目:
        *   1) 找到依赖的题目
        *   2) 获取依赖的题目的分数
        *   3) 获取依赖的分段scoreRanges,只要isEnable的
        *   4) 对比依赖的题目的分数,是否在scoreRanges里
        *     4.1) 在区间里:返回pass,判断下一个依赖
        *     4.2) 不在区间里: 结束函数,返回false
        * 2. 循环题目结束,整个循环过程没有跳出函数的话,返回true
        */
      } else {
        return true
      }
    },

    // 设置下一题跳转
    setNext(pre) {
      this.curIndex = this.curIndex + 1
      if (this.curIndex == this.questions.length - 1) {
        this.isLast = true;
      }

      if (this.curIndex === this.questions.length) {
        this.endSurvey()
      } else {
        // 判断是否满足该题目出现的所需的依赖
        var isDepOk = this.getQuestionDep(this.curIndex)
        console.log('isDepOk', isDepOk)
        if (isDepOk) {
          this.questions[this.curIndex].prev = pre || this.curIndex - 1
        } else {
          this.setNext(pre || this.curIndex - 1)
        }
      }
    },

    // 跳转到指定题目,skipIndex是要跳转到的题目的序号
    skipToQuestion(skipIndex) {
      var curIndex = this.curIndex
      this.curIndex = skipIndex - 1
      this.questions[this.curIndex].prev = curIndex
    },

    // 保存问卷
    saveSurvey() {
      var saveData = {}
      this.endTime = this.getTime()
      var startTime = this.startTime
      var endTime = this.endTime
      var age = this.extraForm.age
      var gender = this.extraForm.gender
      var isValid = this.isValid
      var questions = []
      _.each(this.questions, (question) => {
        questions.push(this.convertQuestionData(question))
      })

      let startPosition = 0
      _.each(this.surveys, (survey, index) => {
        let length = survey.questionsLength
        survey.questions = _.slice(questions, startPosition, startPosition + length)
        startPosition += length
      })

      saveData.startTime = startTime
      saveData.endTime = endTime
      saveData.age = age
      saveData.gender = gender
      saveData.isValid = isValid
      saveData.questionnaires = this.surveys
      saveData.doorNo = this.doorNo
      saveData.doorId = this.doorId
      saveData.account = this.uniqId

      console.log('<================== 提交的数据saveData ===================>', saveData)

      this.submitData(saveData)
    },

    async submitData(data) {
      let res = await window.instance.post(openSurveyReqUrl + 'questionnaire/submitSurvey', data)
      res = res.data
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '问卷提交成功'
        })
      }
    },

    // 结束问卷
    endSurvey() {
      this.isOver = true
    },

    // 把页面的question格式转换成要提交的question格式
    convertQuestionData(question) {
      console.log('question', question)
      var questionId = question.questionId
      var questionType = question.type
      var result = {}
      result.questionId = questionId
      if (questionType == 1) {
        var itemId = question.selected
        let content
        _.each(question.items, (item, index) => {
          if (item.id == itemId) {
            content = item.context || ''
          }
        })
        var items = [{ 'id': itemId, 'content': content }]
        result.items = items
      } else if (questionType == 2) {
        var itemIds = question.selected
        var items = []
        _.each(itemIds, (itemId) => {
          var selectedItem = _.find(question.items, function (item) {
            return item.id == itemId
          })
          var content = selectedItem.context || ''
          var item = { 'id': itemId, 'content': content }
          items.push(item)
        })
        result.items = items
      } else if (questionType == 3) {
        var score = question.score
        result.score = score
      } else if (questionType == 4) {
        var content = question.description || ''
        result.content = content
      }
      return result
    },

    getTime() {
      var myDate = new Date()
      var myYear = myDate.getFullYear() // 获取完整的年份(4位,1970-????)
      var myMonth = myDate.getMonth() + 1 // 获取当前月份(0-11,0代表1月)
      var myToday = myDate.getDate() // 获取当前日(1-31)
      var myHour = myDate.getHours() // 获取当前小时数(0-23)
      var myMinute = myDate.getMinutes() // 获取当前分钟数(0-59)
      var mySecond = myDate.getSeconds() // 获取当前秒数(0-59)
      var nowTime

      nowTime = myYear + '-' + this.fillZero(myMonth) + '-' + this.fillZero(myToday) + ' ' + this.fillZero(myHour) + ':' +
        this.fillZero(myMinute) + ':' + this.fillZero(mySecond)
      return nowTime
    },

    fillZero(str) {
      var realNum
      if (str < 10) {
        realNum = '0' + str
      } else {
        realNum = str
      }
      return realNum
    },
    uploadClick(index) {
      this.bottomDrawer = true;

      this.imageIndex = index

    },
    fileSelect(type) {
      let btn = document.getElementById(type == 1 ? "upload-btn" : "upload-btn2")
      btn.click()
      this.bottomDrawer = false
    },
    async handleFile(e) {

      let file = e.target.files[0]
      // console.log(file)
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      // const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImage) {
        this.$message.error("上传图片只能是 JPEG、JPG、PNG 格式!");
      }
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 20MB!");
      // }
      this.loading[this.imageIndex] = true

      // let fileUpload = await this.compressionImage(file)
      let form = {
        fileName: file.name,
        clientId: 'c27bda81-901c-11ee-a1d5-00163e3041a8',
        contentType: file.type,
      }
      let res = await instance.post(window.retailink + "/resource/preSigned", form)
      if (res.data.code == 200) {
        let imageUrl = res.data.data.url;
        let objectName = res.data.data.objectName
        // console.log(imageUrl)
        await axios({
          url: imageUrl,
          method: "PUT",
          headers: {
            "Content-Type": file.type
          }, data: file
        })

        let res2 = await instance.post(window.retailink + "/resource/sign", { objectName })
        imageUrl = res2.data.data.url;

        if (this.questions[this.curIndex].uploadImages[this.imageIndex]) {
          this.questions[this.curIndex].uploadImages[this.imageIndex] = imageUrl
        } else {
          this.questions[this.curIndex].uploadImages.push(imageUrl)
        }
      } else {
        this.$message.error("上传失败，请稍后再试！");
      }
      e.target.value = ''
      this.loading[this.imageIndex] = false

    },
    async filterDoor(likePosId) {
      let data = { likePosId }
      if (!/[0-9]{1,6}/i.test(likePosId)) {
        data = { doorName: likePosId }
      }
      data.size = 50
      this.doorLoading = true
      let result = await instance.post(window.pubServer + "/external/getDoorInfo", data)
      if (result.data.code == 200) {
        this.doors = result.data.data.doorInfo
      } else {
        history.doors = []
      }
      this.doorLoading = false
    },
    // compressionImage(file) {
    //   return new Promise((resolve, reject) => {
    //     // eslint-disable-next-line no-new
    //     new ImageCompressor({
    //       file: file,
    //       quality: 1,
    //       maxWidth: 1500,
    //       maxHeight: 1500,
    //       redressOrientation: false,
    //       loose: true,
    //       // 压缩前回调
    //       beforeCompress: function (result) {
    //         // console.log('压缩之前图片尺寸大小: ', result.size/1024/1024)
    //         // console.log('mime 类型: ', result.type)
    //         // console.log(result)
    //       },

    //       success: function (result) {
    //         // console.log('压缩之后图片尺寸大小: ', result.size/1024/1024)
    //         // console.log('mime 类型: ', result.type)
    //         // console.log('实际压缩率： ', ((file.size - result.size) / file.size * 100).toFixed(2) + '%')
    //         // console.log(result)
    //         resolve(result)
    //       },
    //       error(e) {
    //         reject(e)
    //       }
    //     })
    //   })
    // }
  },
  computed: {
    percent: function () {
      let curIndex = this.curIndex + 1
      if (curIndex > 0 && curIndex < this.progress1) {
        return 0
      } else if (curIndex >= this.progress1 && curIndex < this.progress2) {
        return 25
      } else if (curIndex >= this.progress2 && curIndex < this.progress3) {
        return 50
      } else if (curIndex >= this.progress3) {
        return 75
      }
    }
  }
}
</script>

<style lang="sass">
.extraQuestions
  .el-button
    font-weight: 600!important
  .el-radio.is-bordered
    margin: 0px!important
    width: 30%!important
    text-align: center!important
    padding: 12px 0 0 0!important
  .el-radio.is-bordered .el-radio__input
    display: none!important
  .el-radio.is-bordered .el-radio__label
    padding-left: 0!important
  .el-radio
    margin-right: 14px!important
  .el-form-item__label
    text-align: left!important
    margin-right: 4px!important
</style>

<style scoped>
.surveyBox {
  padding: 20px;
  font-weight: 600;
}

.name {
  margin-top: 30px;
}

.name span {
  font-size: 14px;
  color: orange;
  margin-left: 16px;
}

.options {
  margin-top: 30px
}

.score {
  margin-top: 30px
}

.scoreText {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-right: 6px
}

.scoreText span {
  display: inline-block;
  text-align: center;
  margin-right: 0 !important;
  width: 16px;
}

.scoreExp {
  display: flex;
  justify-content: space-between;
  width: calc(100% + 14px);
  margin-left: -9px;
  white-space: pre-wrap
}

.scoreExp span {
  font-size: 12px;
  width: 36px;
  text-align: center;
  white-space: pre-wrap;
}

.scoreTip {
  display: block;
  margin-top: 10px;
  font-size: 14px;
}

.description {
  margin-top: 30px
}

.options div.option {
  padding: 9px 0;
}

.options span.orange {
  font-size: 14px;
  color: orange;
}

.buttons {
  text-align: center;
  margin-top: 40px;
}

.extraQuestions {
  margin-top: 20px;
}

.extraQuestions .title {
  margin-bottom: 20px;
}

.banner {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.banner img {
  width: 100%;
  height: 100%
}

.ageBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.line {
  height: 1px;
  width: 100%;
  background: #ccc;
  margin: -10px 0 0;
}

.bigBtn {
  width: 100%;
}
</style>

<style>
.el-drawer.btt {
  border-radius: 10px;
  overflow: hidden;
}


.privacy {
  position: absolute;
  bottom: 50px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  color: black;
}

.privacy a {
  margin-left: 2px;
  color: #67c23a;
}

.privacy .el-input-group__append {
  background: transparent;
  border-color: transparent;
}

.privacy .el-checkbox__input {
  display: block !important;
  border-color: #67c23a !important;
  height: 14px !important;
  width: 14px !important;
  overflow: hidden;
}

.privacy .el-checkbox__input.is_checked,
.privacy .el-checkbox__input.is_checked.is_focus,
.privacy .el-checkbox__input.is_focus {
  display: block !important;
  border-color: #67c23a !important;
  height: 14px !important;
  width: 14px !important;
  overflow: hidden;
}

.privacy .el-checkbox__inner {
  border-width: 0 !important;
  height: 14px;
  width: 14px;
  position: absolute;
  top: 0;
  left: 0;
}


.privacy .el-checkbox__inner:hover {
  border-width: 0 !important;
}

.privacy .el-checkbox.is-bordered.is-checked,
.privacy .el-checkbox__inner:hover {
  border-color: #67c23a !important;
}

.privacy .el-checkbox__input.is-checked .el-checkbox__inner,
.privacy .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #67c23a;
  border-color: #67c23a;
}

.el-rate {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-rate__icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 100%;
  transition: all 0ms;
  box-sizing: border-box;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.5);
  /* outline-color: rgba(255, 255, 255, 0.5);
    outline-width: 4px;
    outline-style: solid; */
}

.el-icon-rate-on {
  width: 16px;
  height: 16px;
  background: #67c23a;
}

.el-rate__icon.hover {
  transform: none;
}

.description .el-select-dropdown {
  left: 0px !important;
  width: calc(100% - 20px) !important;
}

.description .el-select-dropdown__item {
  padding: 0 10px !important;
}
</style>

<!--// 可能出现的问题:-->
<!--1.视为无效问卷以后,跳转至问卷结束 ???-->
<!--2.多选题的跳转-->
<!--4.依赖和跳转冲突-->
<!--5.选择题输入项是否必填判断暂无-->



// WEBPACK FOOTER //
// src/openSurvey/pages/NewSurveyPreview.vue